import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'ihm-error',
  templateUrl: './ihm-error.component.html',
  styleUrls: ['./ihm-error.component.scss']
})
export class IhmErrorComponent implements OnInit {
  errorList: Array<any>;
  error: any;
  xtid: string;

  constructor(private route: ActivatedRoute, private location: Location) {}

  ngOnInit() {
    this.errorList = [
      {
        id: 403,
        name: 'Forbidden',
        title: `Stop, hey, what's that sound?`,
        text: `Sorry, the page that you're trying to access is forbidden. Check the URL again,
          refresh the page or choose one of these options:`,
        icon: './assets/images/ihm_cone.png',
        default: false
      },
      {
        id: 404,
        name: 'Not Found',
        title: `Hello... is there anybody in there?`,
        text: `Sorry, the page that you're looking for does not exist. Check the URL again,
          refresh the page or choose one of these options:`,
        icon: './assets/images/ihm_mic.png',
        default: false
      },
      {
        id: 500,
        name: 'Internal Server Error',
        title: 'Help! I need somebody. Not just anybody.',
        text: `Sorry, we were unable to complete your request. Check the URL again,
          refresh the page or choose one of these options:`,
        icon: './assets/images/ihm_umbrella.png',
        default: true
      }
    ];

    this.route.params.subscribe(params => {
      const errorId = params && params.errorId ? Number(params.errorId) : 404;
      this.error = this.getErrorById(errorId);
    });

    this.route.queryParams.subscribe(params => {
      this.xtid = params && params.xtid ? params.xtid : '';
    });
  }

  getErrorById(errorId: number): any {
    const error = this.errorList.find(err => err.id === errorId);
    return error ? error : this.errorList.find(err => err.default);
  }

  goBack() {
    this.location.back();
  }
}
